import React from "react";
import icon from "../../assets/Person.svg";

export default function KYCIcon({ size }) {
  return <img src={icon} width={size} />;
}
